/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_wt_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why does my kitchen scale round differently than this converter?`)
};

const es_uc_wt_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Por qué mi báscula de cocina redondea de manera diferente que este conversor?`)
};

const de_uc_wt_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warum rundet meine Küchenwaage anders als dieser Umrechner?`)
};

const nl_uc_wt_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waarom rondt mijn keukenweegschaal anders af dan deze convertor?`)
};

const fr_uc_wt_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourquoi ma balance de cuisine arrondit-elle différemment que ce convertisseur ?`)
};

const it_uc_wt_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perché la mia bilancia da cucina arrotonda diversamente da questo convertitore?`)
};

const pt_br2_uc_wt_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que minha balança de cozinha arredonda diferentemente que este conversor?`)
};

const pt_uc_wt_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porque é que a minha balança de cozinha arredonda de forma diferente do que este conversor?`)
};

const ja_uc_wt_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`台所スケールがこのコンバーターより異なる丸め方をするのはなぜですか?`)
};

const zh_uc_wt_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[pending translation B]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_wt_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_wt_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_wt_faq4_q", locale)
	if (locale === "en") return en_uc_wt_faq4_q(inputs)
	if (locale === "es") return es_uc_wt_faq4_q(inputs)
	if (locale === "de") return de_uc_wt_faq4_q(inputs)
	if (locale === "nl") return nl_uc_wt_faq4_q(inputs)
	if (locale === "fr") return fr_uc_wt_faq4_q(inputs)
	if (locale === "it") return it_uc_wt_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_uc_wt_faq4_q(inputs)
	if (locale === "pt") return pt_uc_wt_faq4_q(inputs)
	if (locale === "ja") return ja_uc_wt_faq4_q(inputs)
	return zh_uc_wt_faq4_q(inputs)
};